{
  "defaultTitle": "Không thể check-in",
  "defaultMessage": "Vui lòng xác nhận thông tin với điều phối viên của bạn hoặc liên hệ kho hàng",
  "backToHomescreen": "Quay lại màn hình chính",
  "hideErrorLog": "ẨN NHẬT KÝ LỖI",
  "viewErrorLog": "XEM NHẬT KÝ LỖI",
  "errorLogMessageLabel": "Thông báo:",
  "errorLogStatusLabel": "Mã trạng thái:",
  "unknown": "Không xác định"
}
